// extracted by mini-css-extract-plugin
export default {"mainContainer":"Authentication_mainContainer__liGKK","actionsContainer":"Authentication_actionsContainer__3XgJD"};